import React, {useState, useEffect} from "react";
import "./Phone.css";
import DataCard from "../../components/common/DataCard/DataCard";
import PhoneTable from "./PhoneTable";
import { useGetPhoneSummeryByUserIdQuery } from "./phoneSlice";
import LoadingSpinner from "../../components/common/LoadingSpinner/LoadingSpinner";
import { selectCurrentUser } from "../auth/authSlice";
import { useSelector } from "react-redux";

const Phones = () => {

  const user = useSelector(selectCurrentUser);

  const {
    data: phoneSummary,
    isLoading,
    isFetching,
    isSuccess,
    isError,
    error,
  } = useGetPhoneSummeryByUserIdQuery(user.userID);

  const [individualSummaryData, setIndividualSummaryData] = useState({
    current: 0,
    target: 0,
    isMonitory: false,
  });

  const [teamSummaryData, setTeamSummaryData] = useState({
    current: 0,
    target: 0,
    isMonitory: false,
  });

  useEffect(() => {
    if (phoneSummary) {
      const data = phoneSummary.ids.map((id) => {
        return phoneSummary.entities[id];
      });
      setIndividualSummaryData({
        current: data[0].individualAchievement,
        target: data[0].individualTarget,
        isMonitory: false,
      });
      setTeamSummaryData({
        current: data[0].teamAchievement,
        target: data[0].teamTarget,
        isMonitory: false,
      });
    }
  }, [phoneSummary]);


  return (
    <>
      <div className="row mb-2 mx-md-0">
        <div className="col-md-6 col-sm-12 pe-md-1 data-card-column-left">
          <DataCard
            data={individualSummaryData}
            title={ "Calls Made"}
          />
        </div>
        <div className="col-md-6 col-sm-12 ps-md-1 data-card-column-right">
          <DataCard
            data={teamSummaryData}
            title={ "Contacts reached out to"}
          />
        </div>
      </div>
      <div className="card content-card">
        <div className="card-body">
          <PhoneTable />
        </div>
      </div>
    </>
  );
};

export default Phones;
